import { combineReducers } from "redux";
import { authReducer } from "../reducers/auth";
import { accountReducer } from "../reducers/account";
import { commonReducer } from "./common";
import { projectReducer } from "./project";
import { extendableReducer } from "./edit";
import { mapReducer } from "./map";
import { loadingReducer } from "./loading";
import { snackbarReducer } from "./snackbars";

const allReducers = combineReducers({
  auth: authReducer,
  common: commonReducer,
  project: projectReducer,
  extendable: extendableReducer,
  map: mapReducer,
  loading: loadingReducer,
  snackbar: snackbarReducer,
  account: accountReducer
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    const { auth } = state;
    state = { auth };
  }

  return allReducers(state, action);
};

export default rootReducer;
